import { render, staticRenderFns } from "./AppAccountMenu.vue?vue&type=template&id=68a6d6c1&scoped=true"
import script from "./AppAccountMenu.vue?vue&type=script&lang=js"
export * from "./AppAccountMenu.vue?vue&type=script&lang=js"
import style0 from "./AppAccountMenu.vue?vue&type=style&index=0&id=68a6d6c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a6d6c1",
  null
  
)

export default component.exports